import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Alert, Button, Container, FormControl, Grid, TextField, Card } from "@mui/material";
import axios from "axios";

const validationSchemaNewsletters = Yup.object().shape({
    name: Yup.string().required("El campo nombre es obligatorio"),
    phone: Yup.string().required("El campo telefono es obligatorio"),
    email: Yup.string().required("El campo correo es obligatorio"),
});

const validationSchemaContacts = Yup.object().shape({
    name: Yup.string().required("El campo nombre es obligatorio"),
    email: Yup.string().required("El campo correo es obligatorio"),
    message: Yup.string().required("El campo mensaje es obligatorio"),
});

const Footer = () => {
    const [alertNewsletters, setAlertNewsletters] = useState(false);
    const [alertContacts, setAlertContacts] = useState(false);
    const baseURL = process.env.REACT_APP_BACKEND_URL;


    const formikNewsletters = useFormik({
        initialValues: {
            name: "",
            phone: "",
            email: "",
        },
        validationSchema: validationSchemaNewsletters,
        onSubmit: async (values) => {
            await axios
                .post(`${baseURL}/api/informations-newsletters`, values)
                .then(function (response) {
                    response.statusText === "OK"
                        ? setAlertNewsletters(true)
                        : setAlertNewsletters(false);

                    setTimeout(() => {
                        setAlertNewsletters(false);
                        formikNewsletters.resetForm();
                    }, 3000);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    });

    const formikContacts = useFormik({
        initialValues: {
            name: "",
            email: "",
            message: "",
        },
        validationSchema: validationSchemaContacts,
        onSubmit: async (values) => {
            await axios
                .post(`${baseURL}/api/informations-contacts`, values)
                .then(function (response) {
                    response.statusText === "OK"
                        ? setAlertContacts(true)
                        : setAlertContacts(false);

                    setTimeout(() => {
                        setAlertContacts(false);
                        formikContacts.resetForm();
                    }, 3000);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    });

    return (
        <Container>
            <Grid container spacing={3}>

                <Grid item md={4} xs={12}>
                    <h2>Suscríbete a nuestro newsletter</h2>
                    <FormControl fullWidth>
                        <TextField
                            type="text"
                            label="Nombre"
                            required
                            name="name"
                            onChange={formikNewsletters.handleChange}
                            value={formikNewsletters.values.name}
                            error={
                                formikNewsletters.errors.name &&
                                    formikNewsletters.touched.name ? true : false
                            }
                            style={{ marginBottom: "5px", marginTop: "5px" }}
                            helperText={
                                formikNewsletters.errors.name &&
                                formikNewsletters.touched.name &&
                                formikNewsletters.errors.name
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            type="text"
                            label="Teléfono"
                            required
                            name="phone"
                            onChange={formikNewsletters.handleChange}
                            value={formikNewsletters.values.phone}
                            error={
                                formikNewsletters.errors.phone &&
                                    formikNewsletters.touched.phone ? true : false
                            }
                            style={{ marginBottom: "5px", marginTop: "5px" }}
                            helperText={
                                formikNewsletters.errors.phone &&
                                formikNewsletters.touched.phone &&
                                formikNewsletters.errors.phone
                            }
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            type="text"
                            label="Correo"
                            required
                            name="email"
                            style={{ marginBottom: "5px", marginTop: "5px" }}
                            onChange={formikNewsletters.handleChange}
                            value={formikNewsletters.values.email}
                            error={
                                formikNewsletters.errors.email &&
                                    formikNewsletters.touched.email ? true : false
                            }
                            helperText={
                                formikNewsletters.errors.email &&
                                formikNewsletters.touched.email &&
                                formikNewsletters.errors.email
                            }
                        />
                    </FormControl>

                    <Button
                        style={{ backgroundColor: '#70d44b', color: "#fff" }}
                        onClick={() => formikNewsletters.handleSubmit()}
                    >
                        {alertNewsletters ? (
                            <Alert
                                className="design-component-instance-node-3"
                                severity="success"
                            >
                                Información Guardada!
                            </Alert>
                        ) : (
                            "Suscríbete"
                        )}
                    </Button>
                </Grid>

                <Grid item md={6} xs={12}>
                    <h2>Contáctanos</h2>
                    <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    type="text"
                                    label="Nombre"
                                    required
                                    name="name"
                                    onChange={formikContacts.handleChange}
                                    value={formikContacts.values.name}
                                    error={formikContacts.errors.name && formikContacts.touched.name ? true : false}
                                    helperText={
                                        formikContacts.errors.name &&
                                        formikContacts.touched.name &&
                                        formikContacts.errors.name
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    type="text"
                                    label="Correo"
                                    required
                                    name="email"
                                    onChange={formikContacts.handleChange}
                                    value={formikContacts.values.email}
                                    error={formikContacts.errors.email && formikContacts.touched.email ? true : false}
                                    helperText={
                                        formikContacts.errors.email &&
                                        formikContacts.touched.email &&
                                        formikContacts.errors.email
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    type="text"
                                    label="Mensaje"
                                    required
                                    multiline
                                    rows={2}
                                    defaultValue="Default Value"
                                    name="message"
                                    onChange={formikContacts.handleChange}
                                    value={formikContacts.values.message}
                                    error={
                                        formikContacts.errors.message && formikContacts.touched.message ? true : false
                                    }
                                    helperText={
                                        formikContacts.errors.message &&
                                        formikContacts.touched.message &&
                                        formikContacts.errors.message
                                    }
                                />
                            </FormControl>
                            <br></br>
                            <br></br>
                            <Button
                                style={{ backgroundColor: "#70d44b", color: "#fff" }}
                                onClick={() => formikContacts.handleSubmit()}
                            >
                                {alertContacts ? (
                                    <Alert
                                        className="design-component-instance-node-3"
                                        severity="success"
                                    >
                                        Información Guardada!
                                    </Alert>
                                ) : (
                                    "Enviar"
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item md={2} style={{ marginTop: '5%' }}>
                    <div className="rectangle-7" >
                        <p className="element-todos-los">
                            <strong>© 2023. <br />
                                Todos los derechos reservados para XM S.A.S.P</strong>
                        </p>
                    </div>
                </Grid>
            </Grid>
        </Container >
    )
}

Footer.propTypes = {}

export default Footer